const BlogCatalog = () => import('@/views/modules/plants/BlogCatalog.vue');
const SingleBlog = () => import('@/views/modules/plants/SingleBlog.vue');
const FavoritesPlants = () =>
    import('@/views/modules/plants/FavoritesPlants.vue');
const PlantsCatalog = () => import('@/views/modules/plants/PlantsCatalog.vue');
const PlantsCalendar = () => import('@/views/modules/plants/PlantsCalendar.vue');
const SinglePlant = () => import('@/views/modules/plants/SinglePlant.vue');
const GlossaryCatalog = () => import('@/views/modules/plants/GlossaryCatalog.vue');
export default [
    {
        path: '/blog/catalog',
        name: 'blog-catalog',
        component: BlogCatalog,
        meta: { hideForPortalTypeBooks: true },
    },
    {
        path: '/blog/:id',
        name: 'single-blog',
        component: SingleBlog,
        meta: { requiresAuth: true, hideForPortalTypeBooks: true  },
    },
    {
        path: '/my-profile/favorites/plants',
        name: 'favorites-plants',
        component: FavoritesPlants,
        meta: { requiresAuth: true, hideForPortalTypeBooks: true },
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: PlantsCalendar,
        meta: { hideForPortalTypeBooks: true },
    },
    {
        path: '/plants/catalog',
        name: 'plants-catalog',
        component: PlantsCatalog,
        meta: { hideForPortalTypeBooks: true },
    },
    {
        path: '/plants/:id',
        name: 'single-plant',
        component: SinglePlant,
        meta: { requiresAuth: true, hideForPortalTypeBooks: true },
    },
    {
        path: '/glossary',
        name: 'glossary',
        component: GlossaryCatalog,
        meta: { hideForPortalTypeBooks: true },
    },
];
